var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgIconLanguageEnglish = function SvgIconLanguageEnglish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    x: 1,
    y: 1,
    fill: "#FFF",
    stroke: "#2283F6",
    strokeWidth: 2,
    rx: 13
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2283F6",
    d: "M38.282 35.326l-1.914 6.732h10.89l-1.782-6.468c-1.782-6.402-2.706-9.768-3.498-13.86h-.264c-.792 3.96-1.782 7.722-3.432 13.596zm-3.366-20.592h14.058L63.032 61h-10.56l-2.904-10.626h-15.51L31.088 61H20.924l13.992-46.266z"
  }))));
};
export default SvgIconLanguageEnglish;